import bem from 'utils/bem';

export const block = bem('paid-subscription-success-modal');
